import {range} from "utils/DBUtils";
import React from 'react';
import {
  TotalGuaranteedToolTip,
  CostPerEngagementToolTip
} from "components/break/tooltips/breaks-account-information-tool-tips";
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    key: "breaksAccountInformation",
    showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored'),
    props: {
        headerKey: 'editbreak.section.account.heading'
    },

    fields: [
        {
          conditionalSection: true,
          name: "hasMaxParticipants",
          required: true,
          props: {
              labelKey: 'editbreak.account_info.has_guaranteed_engagements'
          },

          fields: [
            {
                type: 'number',
                name: 'maxParticipants',

                props: {
                    labelKey: 'editbreak.account_info.guaranteed_engagements',
                    helpContent: <TotalGuaranteedToolTip/>,
                    helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.account_info.guaranteed_engagements'}/></IntlProvider>
                }
            }
          ]
        },  // end has guaranteed engagements
        {
          conditionalSection: true,
          name: "hasGrossRevenuePerStart",
          required: true,
          props: {
              labelKey: 'editbreak.account_info.has_cost_per_engagement'
          },

          fields: [
            {
                type: 'text',
                name: 'grossRevenuePerStart',

                props: {
                    labelKey: 'editbreak.account_info.cost_per_engagement',
                    helpContent: <CostPerEngagementToolTip/>,
                    helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.account_info.cost_per_engagement'}/></IntlProvider>
                }
            }
          ]
        }, // end has cost per engagement
        {
          type: 'dropdown',
          name: 'currency',
          required: true,
          props: {
            labelKey: 'editbreak.account_info.currency',
            options: [
              {
                value: 'USD',
                textKey: 'editbreak.account_info.currency.usd'
              },
              {
                value: 'GBP',
                textKey: 'editbreak.account_info.currency.gbp'
              }
            ]
          }
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksAccountInformation.js